/**
 * PANOYA KOPYALAMA — tek yer.
 *
 * `navigator.clipboard` yalnızca GÜVENLİ BAĞLAMDA (https ya da localhost)
 * çalışır; uygulama dışarıya https ile çıkıyor ama yerel ağdan düz http ile
 * açıldığında API tanımsız olur ve tıklama sessizce hiçbir şey yapmaz. Bu
 * yüzden eski `execCommand` yolu yedekte duruyor.
 */
import { toast } from 'sonner';

export async function panoyaKopyala(metin, etiket = 'Kopyalandı') {
  const deger = String(metin ?? '').trim();
  if (!deger) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(deger);
    } else {
      const kutu = document.createElement('textarea');
      kutu.value = deger;
      // Ekranda görünmesin ama seçilebilsin; `display:none` seçime izin vermez
      kutu.style.position = 'fixed';
      kutu.style.top = '-1000px';
      kutu.setAttribute('readonly', '');
      document.body.appendChild(kutu);
      kutu.select();
      const oldu = document.execCommand('copy');
      kutu.remove();
      if (!oldu) throw new Error('execCommand basarisiz');
    }
    toast.success(etiket);
    return true;
  } catch {
    // Tarayıcı izin vermediyse kullanıcı elle kopyalayabilsin diye değeri göster
    toast.error(`Kopyalanamadı — elle kopyalayın: ${deger}`, { duration: 10000 });
    return false;
  }
}
